import { useTranslation } from 'react-i18next';
import { formatAmountInThousands } from "../../service/utils/formatters";
import { formatAmount } from "../../service/utils/orderUtils";

function FactureCount({ facturations }) {
  const { t } = useTranslation('facturation');
  
  const stats = {
    total: facturations.length,
    brouillon: facturations.filter(f => f.facturationStatut === 0).length,
    valide: facturations.filter(f => f.facturationStatut === 1).length,
    totalAuc: facturations.reduce((sum, f) => sum + f.totalAuc, 0)
  };

  return (
    <div className="row mb-4">
      {/* Total Facturations */}
      <div className="col-xl-3 col-sm-6">
        <div className="card card-stats">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                <div className="avatar-sm bg-primary bg-opacity-10 text-center rounded">
                  <i className={`${t('stats.cards.total.icon')} text-white font-size-24`}></i>
                </div>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="text-muted mb-1">{t('stats.cards.total.title')}</p>
                <h4 className="mb-0">{formatAmount(stats.total)}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* En Brouillon */}
      <div className="col-xl-3 col-sm-6">
        <div className="card card-stats">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                <div className="avatar-sm bg-warning bg-opacity-10 text-center rounded">
                  <i className={`${t('stats.cards.draft.icon')} text-warning font-size-24`}></i>
                </div>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="text-muted mb-1">{t('stats.cards.draft.title')}</p>
                <h4 className="mb-0">{formatAmount(stats.brouillon)}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Validées */}
      <div className="col-xl-3 col-sm-6">
        <div className="card card-stats">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                <div className="avatar-sm bg-success bg-opacity-10 text-center rounded">
                  <i className={`${t('stats.cards.validated.icon')} text-success font-size-24`}></i>
                </div>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="text-muted mb-1">{t('stats.cards.validated.title')}</p>
                <h4 className="mb-0">{formatAmount(stats.valide)}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Total AUC */}
      <div className="col-xl-3 col-sm-6">
        <div className="card card-stats">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                <div className="avatar-sm bg-info bg-opacity-10 text-center rounded">
                  <i className={`${t('stats.cards.totalAuc.icon')} text-info font-size-24`}></i>
                </div>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="text-muted mb-1">{t('stats.cards.totalAuc.title')}</p>
                <h4 className="mb-0">{formatAmountInThousands(stats.totalAuc)}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FactureCount;